import axiosResiInstance from "../http/axiosResi";

const ERROR_LOG_TYPE = "site";

const send = (message, context) => {
    return axiosResiInstance.post("/error/frontend-log", {
        type: ERROR_LOG_TYPE,
        message,
        context,
    });
};

const reportFailedRequest = function (e, req, file, query = null) {
    const response = e.response;
    let message;
    let context = null;

    const request =
        "HOST: " +
        (req && req.headers ? req.headers.host : "") +
        "\n\n" +
        "URL: " +
        (req && req.originalUrl ? req.originalUrl : "") +
        "\n\n" +
        "REFERRER URL: " +
        (req && req.headers ? req.headers.referer : "") +
        "\n\n" +
        "HEADERS: " +
        JSON.stringify(req && req.headers ? req.headers : {});

    if (response) {
        const config = e.response.config;
        const responseError =
            response.data && response.data.error
                ? "ERRORS: " + JSON.stringify(response.data.error) + "\n\n"
                : "";

        message =
            "FAILED REQUEST WITH CODE " +
            response.status +
            ": " +
            "[" +
            config.method.toUpperCase() +
            "] " +
            config.url +
            ": " +
            response.statusText +
            ", " +
            file +
            "\n\n" +
            responseError +
            request;

        if (config.params && query) {
            context = JSON.stringify({ ...config.params, ...query });
        } else if (config.params) {
            context = JSON.stringify(config.params);
        } else if (query) {
            context = JSON.stringify(query);
        }

        if (e.stack) {
            context = context + "\n\nSTACK: " + e.stack;
        }
    } else {
        // API SERVER:
        // 500 Internal Server Error
        message =
            "FAILED REQUEST WITH CODE 500: Internal Server Error, " +
            file +
            "\n\n" +
            request;

        if (query) {
            context = JSON.stringify({ query });
        }
    }

    send(message, context)
        .then((r) => {})
        .catch((e) => {});
};

export default reportFailedRequest;
